import React from 'react'

const DeleteModal = () => {
  return <div></div>
}

export default DeleteModal
